export interface SearchData {
    value?: string | undefined;
    regex?: boolean | undefined;
}
